import { Skeleton } from '@/components/Skeleton';
import { useDevice } from '@/hooks/device';

export const HeaderSkeleton = () => {
  const { isMobileDevice } = useDevice();

  if (isMobileDevice)
    return (
      <Skeleton.Container gap={8}>
        <Skeleton.Rect rx="25" ry="25" width={45} height={40} />
        <Skeleton.Container gap={8}>
          <Skeleton.Rect rx="25" ry="25" height={40} />
          <Skeleton.Rect rx="25" ry="25" height={40} />
        </Skeleton.Container>
      </Skeleton.Container>
    );

  return (
    <Skeleton.Container gap={8}>
      <Skeleton.Rect rx="25" ry="25" width={128} height={40} />
      <Skeleton.Rect rx="25" ry="25" width={128} height={40} />
      <Skeleton.Rect rx="25" ry="25" width={40} height={40} />
    </Skeleton.Container>
  );
};
